import React, { useState } from 'react';
import { IconChevronDown } from '@tabler/icons-react';

const CollapsibleSection = ({ title, subtitle, icon, isDefaultOpen = false, children }) => {
  const [isOpen, setIsOpen] = useState(isDefaultOpen);

  return (
    <div className={`ub-collapsible-section ${isOpen ? 'ub-open' : ''}`}>
      <button
        className="ub-collapsible-header"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
      >
        <div className="ub-collapsible-header-content">
          {icon && <div className="ub-collapsible-icon">{icon}</div>}
          <div className="ub-collapsible-text">
            <h2 className="ub-collapsible-title">{title}</h2>
            {subtitle && <p className="ub-collapsible-subtitle">{subtitle}</p>}
          </div>
        </div>
        <div className={`ub-collapsible-arrow ${isOpen ? 'ub-rotated' : ''}`}>
          <IconChevronDown size={24} strokeWidth={2} />
        </div>
      </button>

      <div className="ub-collapsible-content">
        <div className="ub-collapsible-content-inner">
          {children}
        </div>
      </div>
    </div>
  );
};

export default CollapsibleSection;
